import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Box } from '@chatterbug/aaron'

const UnitExerciseListSkeleton = ({ titleSection, listSection }) => (
  <Box as="section">
    <Box as="text" variant="text.h3">
      {titleSection}
    </Box>
    <Grid
      gridTemplateColumns={{
        _: '1fr',
        tablet: 'repeat(3, 1fr)',
      }}
      gap="3x"
      mt="2x"
    >
      {listSection}
    </Grid>
  </Box>
)

UnitExerciseListSkeleton.propTypes = {
  titleSection: PropTypes.any,
  listSection: PropTypes.any,
}
export default UnitExerciseListSkeleton
